import $ from 'jquery'
import { alert_error, post_json, get_csrf, get_myinfo } from './common'
import * as qs from 'querystring'
import * as Cookies from 'js-cookie'

$(init)

function init () {
  if ([ 'register', 'login', 'signin', 'signup', 'reset-password' ].indexOf(location.hash.substring(1)) != -1) {
    let page = location.hash.substring(1)
    let ALIASES = {
      'signup': 'register',
      'signin': 'login',
    }
    if (ALIASES[page]) {
      page = ALIASES[page]
    }
    let rto = (location+'')
    if (rto.endsWith(location.hash)) {
      rto = rto.substring(0, rto.length - location.hash.length)
    }
    if (page != 'reset-password') {
      ;(async () => {
        let myinfo
        try {
          myinfo = await get_myinfo()
        } finally {
          if (myinfo) {
            alert_error({ title: 'Already signed in', message: "Can't " + (page == 'register' ? 'sign up' : 'sign in') + ' while you are already signed in.' })
            history.replaceState(null, null, rto)
          } else {
            show_login_modal(page, rto)
          }
        }
      })()
    } else {
      show_login_modal(page, rto)
    }
  }
  // subscription
  $('.subscribe-link').on('click', async ($evt) => {
    $evt.preventDefault()
    $('#subscribe-modal').modal('show')
  })
  $('#subscribe-form').on('submit', async ($evt) => {
    $evt.preventDefault()
    try {
      let data = { }
      for (let field of ['email']) {
        data[field] = $(`#subscribe-form [name=${field}]`).val()
      }
      await post_json('/users/email-subscribe', data)
      $('#subscribe-form').addClass('d-none')
      $('#subscribe-form-thankyou').removeClass('d-none')
      try {
        gtag('event', 'subscribe')
      } catch (err) {
        console.warn('GA event error: ', err)
      }
    } catch (err) {
      alert_error(err)
    }
  })

  if (Cookies.get('pa') != '1') {
    $('.privacy-notice-overlay').removeClass('d-none')
    $('.privacy-notice-hide').on('click', ($evt) => {
      $evt.preventDefault()
      Cookies.set('pa', '1', { expires: 365 * 2 });
      $('.privacy-notice-overlay').addClass('d-none')
    })
  }

  let query = qs.parse(location.search.substr(1))
  if (!!query.rc) {
    Cookies.set('rc', query.rc, { expires: 30 })
  }

  // login/register modal
  $(document).on('x-show-login-modal', ($evt, data) => {
    let redirect = data ? data.redirect : null
    show_login_modal('login', redirect)
  })
  $(document).on('x-show-register-modal', ($evt, data) => {
    let redirect = data ? data.redirect : null
    show_login_modal('register', redirect)
  })
  $('#register-form-modal').on('submit', ($evt) => {
    let pass = $('#register-form-modal [name=password]').val()
    let cpass = $('#register-form-modal [name=confirm_password]').val()
    if (pass != cpass) {
      $evt.preventDefault()
      alert_error({ message: 'Confirm password do not match!' })
    }
    let acceptinp = $('#register-form-modal [name=accept_terms]')[0]
    if (!acceptinp.checked) {
      $evt.preventDefault()
      alert_error({ message: 'Please check the terms of service before registering.' })
    }
  })
  $('.login-form-modal-goto-register').on('click', ($evt) => {
    $evt.preventDefault()
    let redirect = $('#login-form-modal').data('redirect')
    show_login_modal('register', redirect)
  })
  $('.login-form-modal-goto-login').on('click', ($evt) => {
    $evt.preventDefault()
    let redirect = $('#register-form-modal').data('redirect')
    show_login_modal('login', redirect)
  })
  $('.login-form-modal-goto-reset-password').on('click', ($evt) => {
    $evt.preventDefault()
    show_login_modal('reset-password')
  })
  $('#reset-password-form-modal').on('submit', async ($evt) => {
    $evt.preventDefault()
    let email = $('#reset-password-form-modal [name=email]').prop('value')
    try {
      if (!email) {
        throw { message: 'Please enter an email' }
      }
      await post_json('/users/send-reset-password', { email })
      $('#reset-password-form-modal').toggleClass('d-none', true)
      $('#reset-password-form-modal-success').toggleClass('d-none', false)
    } catch (err) {
      alert_error(err)
    }
  })
}


async function show_login_modal (page, backto) {
  let $modal = $('#login-modal')
  try {
    $modal.find('button[type=submit]').prop('disabled', true)

    $modal.modal('show')
    $modal.toggleClass('hide-register', page != 'register')
    $modal.toggleClass('hide-login', page != 'login')
    $modal.toggleClass('hide-reset-password', page != 'reset-password')

    let referral_code = Cookies.get('rc')
    if (!!referral_code) {
      $modal.find('input[name=referral_code]').attr('value', referral_code)
    }
    let csrf = await get_csrf()
    $modal.find('input[name=_csrf]').attr('value', csrf)
    if (!backto) {
      if (location.pathname.indexOf('/didlogin/') == 0) {
        let query = qs.parse(location.search.substr(1))
        backto = query.r || ""
      } else {
        backto = location.pathname + location.search + location.hash
      }
    }
    // set redirect field
    if (['register','login'].indexOf(page) != -1) {
      let isregister = page == 'register'
      let $form = $((isregister?'#register':'#login') + '-form-modal')
      $form.find('input[name=redirect]')
        .attr('value', '/didlogin/?' + (isregister?'register&':'') + 'r=' +
              encodeURIComponent(backto))
      $form.data('redirect', backto)
    }
  } catch (err) {
    $modal.modal('hide')
    alert_error(err)
  } finally {
    $modal.find('button[type=submit]').prop('disabled', false)
  }
}

